import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default function getFormattedDate(
  date: string | number,
  format = 'DD.MM.YYYY',
) {
  return dayjs(date).utc(true).format(format);
}
